import React from "react";
import "../post.css";
import DayTen from "../images/day_ten.png";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Ten</h2>
        <img className="image" alt="itinerary" src={DayTen} />
        <div className="infobar">
          <div className="info">29 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Light and ez. There is opportunity to do last minute shopping and
          sight-seeing.
        </p>
        <h3>Evening</h3>
        <p>
          Take the train to Kansai International Airport. There are two types
          that run there - normal and express. Try not to take the wrong one.
          But if you do, you just have to pay the difference.
        </p>
        <h3>Night</h3>
        <p>That's the end of the trip. Goodbye to Japan, for now.</p>
      </div>
    );
  }
}
